
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

import { ChatService } from '@/lib/chat/ChatService'
import { ChatMessage } from '@/lib/chat/ChatMessage'

import { FileUtils } from '@/lib/utils/FileUtils'
import { Game } from '../../lib/models/Game'

import BacMultiselectWrapper from '../BacMultiselectWrapper.vue'
import { User } from '../../lib/models/User'
import { Team } from '../../lib/models/Team'

import Multiselect from 'vue-multiselect'
import { RallyRound } from '../../lib/models/RallyRound'

@Component({
  components: {
    BacMultiselectWrapper,
    Multiselect
  }
})
export default class ChatAttachmentUploadComponent extends Vue {
  @Prop({ default: null }) chatService!: ChatService | null;
  @Prop({ default: null }) selectedChallenge!: Game | null;

  posters: User[] = []
  internalPoster = this.user

  get poster () {
    return this.internalPoster
  }

  set poster (user) {
    // this.poster = user
    this.$store.state.Chat.sendMessage.customPosterId = user.id
  }

  get files (): File[] {
    return this.$store.state.Chat.uploadFiles
  }

  get user () {
    return this.$store.state.LoggedInUser.user
  }

  get posterAsMultiselect () {
    return this.posters.reverse().map(poster => {
      return { name: `${poster.firstname} ${poster.lastname}`, id: poster.id }
    })
  }

  mounted () {
    this.loadPosters()
  }

  postersLoading = false
  @Watch('user')
  async loadPosters () {
    if (!this.poster && !this.internalPoster) {
      return // added cause this request is loaded many times
    }
    if (this.postersLoading) {
      return
    }
    if (this.user && this.user.isAdmin) {
      this.poster = this.user
      this.postersLoading = true
      this.posters = await this.$store.state.PageURLRallyRound.rallyRound.getUsers(this.$route.params.rallyRoundId)
      this.postersLoading = false
    }
  }

  generateFilePreviewUrl (file: File) {
    return URL.createObjectURL(file)
  }

  removeFile (file: File) {
    this.$store.commit('removeUploadFile', file)
  }
}
